import { mergeNsAndName } from '@angular/compiler';
import { Component, ElementRef, EventEmitter, HostBinding, Input, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { BidRequestModel } from 'src/app/models';
import { AuctionLotService, AuctionService, BidIncrementService, CustomerService, MyAuctionLotService } from 'src/app/services';
import { fadeAnimation } from 'src/app/shared/animations';
import { BidListCardComponent } from '../../components';
import { AuctionLotItemComponent } from 'src/app/components';

@Component({
    selector: 'modal-confirm-bids',
    styleUrls: ['./modal-confirm-bids.component.scss'],
    templateUrl: 'modal-confirm-bids.component.html',
    animations: [fadeAnimation],
})
export class ModalConfirmBidsComponent {
    @Input() processing: boolean = false;
    @Input() error: boolean = false;
    @Input() errorMessage: string = "";
    @Input() title: string = "";
    @Input() bids: BidListCardComponent[];
    @Output() save: EventEmitter<NgForm> = new EventEmitter();

    IsConfirmBidsClicked: boolean = false;
    IsBidAgainClicked: boolean = false;
    IsBidAmountChanged: boolean = false;
    winningBids: any[] = [];
    losingBids: any[] = [];
    notAcceptedBids: any[] = [];

    bidRequests: any[] = [];
    bidResults: any[] = [];

    @ViewChild("bidEntry") bidEntry: ElementRef;
    @ViewChild("backToWatchList") backToWatchList: ElementRef;
    @ViewChild("confirmBids") confirmBids: ElementRef;
    @ViewChild("noValidBids") noValidBids: NgbTooltip;

    @HostBinding('class') get hostClasses() {
        const classList = [];
        //if (this.processing) classList.push('loading-overlay');
        return classList;
    }

    constructor(
        public activeModal: NgbActiveModal,
        public auctionService: AuctionService,
        public auctionLotService: AuctionLotService,
        public myAuctionLotService: MyAuctionLotService,
        private customerService: CustomerService,
        private bidIncrementService: BidIncrementService
    ) {
        let me = this;
    }

    ngOnInit() {
        let me = this;

        me.ValidateBids().then(() => {
            me.SetFocus();
        })

        setTimeout(() => { me.noValidBids.open(); }, 0);
    }

    ngAfterViewInit() {
        let me = this;
        me.SetFocus();
        // setTimeout(() => {
        //     console.log('Attempting focus', me.confirmBids);
        //     me.confirmBids?.nativeElement?.focus();
        // }, 100);
        //me.confirmBids?.nativeElement?.focus();
    }

    ValidateBids(): Promise<void> {
        let me = this;
        let adjustments = [];
        for (let i = 0; i < me.bids.length; i++) {
            let bid = me.bids[i];
            if (!bid.NewBidAmountValidated) {
                adjustments.push(bid.AdjustToIncrement());
            }
        }
        return Promise.all(adjustments).then(x => console.log('ValidateBids complete'));
    }

    SetFocus(exit?: boolean) {
        setTimeout(() => {
            let me = this;
            // console.log('Attempting focus', me.confirmBids, me.bidEntry, me.backToWatchList);

            if (me.confirmBids?.nativeElement && !me.confirmBids?.nativeElement?.disabled) {
                // console.log('Focusing on confirm button', me.confirmBids);
                me.confirmBids?.nativeElement?.focus();
            } else if (me.bidEntry?.nativeElement && !exit) {
                // console.log('Focusing on bid entry', me.bidEntry);
                me.bidEntry?.nativeElement?.focus();
            } else {
                // console.log('Focusing on back button', me.backToWatchList, me.backToWatchList?.nativeElement?.disabled);
                me.backToWatchList?.nativeElement?.focus();
            }
        }, 0);
    }

    get AnyProcessing() {
        return this.processing || this.BidsProcessing;
    }

    get ValidBids() {
        return this.bids.filter(x => x.NewBidIsValid && x.LotIsBiddable);
    }

    get BidsProcessing() {
        return this.bids.filter(x => x.processing).length > 0;
    }

    get Items() {
        return this.ValidBids.length;
    }
    get SubTotal() {
        return this.ValidBids.reduce((sum, current) => sum + current.SubTotal, 0);
    }
    get BuyerPremium() {
        let validBids = this.bids.filter(x => x.NewBidIsValid);
        return validBids.reduce((sum, current) => sum + current.BuyerPremium, 0) / validBids.length; // average premium
    }
    get PremiumTotal() {
        return this.ValidBids.reduce((sum, current) => sum + current.PremiumTotal, 0);
    }
    get Total() {
        return this.ValidBids.reduce((sum, current) => sum + current.Total, 0);
    }

    get HasUnsuccessfulBids() {
        return this.IsConfirmBidsClicked && this.winningBids.length < this.bids.length && (this.losingBids?.length || this.notAcceptedBids?.length);
    }
    get HasPossibleBids() {
        return this.bids.filter(x => x.newBidAmt > 0).length > 0;
    }

    Save(form, e) {
        this.save.emit(form);
    }

    Format(arr: string[]) {
        return arr.filter(Boolean).join(", ");
    }

    BackToBidsList() {
        let me = this;
        me.activeModal.close();
    }

    BackToConfirmation() {
        let me = this;
        me.processing = true;
        // Take only bids with amounts specified, then take back to confirmation screen
        let selectedBids = this.bids.filter(x => x.newBidAmt && x.LotIsBiddable);
        me.bids = selectedBids;
        // Reset all the modal variables
        me.IsConfirmBidsClicked = false;
        me.IsBidAgainClicked = false;
        me.IsBidAmountChanged = false;
        me.winningBids = [];
        me.losingBids = [];
        me.notAcceptedBids = [];
        me.bidRequests = [];
        me.bidResults = [];
        me.processing = false;

        me.SetFocus();
    }

    ConfirmBids() {
        let me = this;

        me.save.emit(null);

        me.processing = true;

        me.noValidBids.close();

        let adjustments = [];
        for (let i = 0; i < me.bids.length; i++) {
            let bid = me.bids[i];
            bid.errorMessage = null;
            adjustments.push(bid.AdjustToIncrement());
        }

        // console.log('Pending adjustments', adjustments);

        Promise.all(adjustments).then(x => {
            // console.log('Bids adjusted', me.bids);
            me.bidRequests = [];
            me.notAcceptedBids = [];
            for (let i = 0; i < me.bids.length; i++) {
                let bid = me.bids[i];
                if (bid.NewBidIsValid && bid.LotIsBiddable) { // make them confirm again if we needed to adjust their amount
                    me.bidRequests.push(<BidRequestModel>{
                        AuctionLotId: bid.lot.Id,
                        BidAmount: bid.newBidAmt
                    });
                } else {
                    // Only add to 'not accepted' if they haven't already won during this modal
                    if (me.winningBids.indexOf(bid.lot.Id) < 0) {
                        me.notAcceptedBids.push(bid.lot.Id);
                    }
                }
            }
            if (me.bidRequests.length === 0) {
                // console.log('No valid bids to submit');
                me.noValidBids.open();
                me.processing = false;
            } else {
                // console.log('Proceeding with submission');
                me.IsConfirmBidsClicked = true;
                me.IsBidAmountChanged = false;

                // Clear temp data while we wait
                me.bidResults = [];
                /**
                 * Don't clear the winning bids list. If they've won a bid during this screen, 
                 * keep it in the array so we can ignore it for re-bids instead of putting it as 'not accepted'.
                 */
                //me.winningBids = []; 
                me.losingBids = [];
                for (let i = 0; i < me.bids.length; i++) {
                    let bid = me.bids[i];
                    bid.oldBidAmt = null;
                    bid.newBidAmt = null;
                    bid.NewBidAmountValidated = true;
                }

                me.auctionLotService.SubmitBids(me.bidRequests).subscribe((data) => {
                    // console.log('SubmitBids response', data);
                    // { Result: [{ AuctionLotId: 387930, BidAmount: 64, CustomerId: 1 }] }
                    for (let i = 0; i < data.length; i++) {
                        let result = data[i];
                        me.bidResults.push(result);

                        let matchingBid = me.bids.find(x => x.lot.Id === result.AuctionLotId);

                        if (result.Message) {
                            me.notAcceptedBids.push(result.AuctionLotId);
                            matchingBid.errorMessage = result.Message;
                        } else {
                            if (result.CustomerId == me.customerService.customer.Id) {
                                //me.winningBids++;
                                me.winningBids.push(result.AuctionLotId);
                                // console.log('Winning', result);
                            } else {
                                //me.losingBids++;
                                me.losingBids.push(result.AuctionLotId);
                                // console.log('Losing', result);
                            }
                        }
                    }
                    // re-sort the bids list by 'type' of result, i.e. won, lost or not accepted
                    let allBids = [...me.losingBids, ...me.winningBids, ...me.notAcceptedBids];
                    //console.log('allBids', allBids, me.bids);
                    me.bids = me.bids.sort((a, b) => allBids.indexOf(a.lot.Id) - allBids.indexOf(b.lot.Id));
                    //console.log('allBids after sorting', me.bids);

                    me.processing = false;

                    me.SetFocus();
                });
            }
        })
    }

    BidAgain() {
        let me = this;
        me.IsBidAgainClicked = !me.IsBidAgainClicked;
    }

    DeleteBidItem(bid) {
        let me = this;

        me.myAuctionLotService.SetSavedBid(bid.lot.Id, null).subscribe(data => {
            me.bids.splice(me.bids.indexOf(bid), 1);
            if (!me.bids.length) {
                me.activeModal.close();
            }
        });

    }

    bidAmountChanged(bid) {
        let me = this;
        me.IsBidAmountChanged = true;
    }
}